import axios from 'axios'

import { API_URL } from './config'
import { fullLogOut } from './helpers'
import { notifyError } from './errorMessage'

const instance = axios.create({
	baseURL: API_URL
})

instance.interceptors.response.use(
	response => response,
	error => {
		/*
		 * Der vollständige Fehler gehört in die Entwicklungskonsole, nicht auf den
		 * Bildschirm: Auf dem Bildschirm stand bis 05.08.2026 der Satz der
		 * Programmbibliothek vorneweg („Anfrage fehlgeschlagen mit Statuscode
		 * 401."), der verständliche Teil erst dahinter.
		 */
		console.error(
			'Anfrage fehlgeschlagen:',
			error?.config?.url,
			error?.response?.status ?? error?.code ?? '',
			error?.response?.data ?? error?.message
		)

		if (error.response?.status === 401) fullLogOut()

		// `disableToast` setzt, wer den Fehler selbst erklärt — sonst stünden zwei
		// Meldungen übereinander.
		const config = error.config || error.response?.config
		if (!config?.disableToast) notifyError(error)

		return Promise.reject(error)
	}
)

export const getAuthInfo = () => JSON.parse(localStorage.getItem('auth') || '{}')
export const authInfo = getAuthInfo()
if (authInfo.token) instance.defaults.headers['Authorization'] = `Bearer ${authInfo.token}`

export default instance
